import moment from 'moment';

export const isDateDeliveryInPast = (dateDelivery: string | null) => {
    return dateDelivery && moment(dateDelivery).isBefore(moment().startOf('day'));
};
